/**
 * B타입 - OX 문제 입력 컴포넌트
 * 이진 선택 (O/X)
 */

import React, { useState } from 'react';
import { PixelButton } from '../common/PixelButton';

/**
 * OXInput Props
 */
interface OXInputProps {
  /** 답안 제출 콜백 */
  onSubmit: (answer: string) => void;
  /** 비활성화 여부 */
  disabled?: boolean;
}

/**
 * B타입 OX 입력 컴포넌트
 *
 * - 2개의 큰 버튼 (O / X)
 * - 선택된 버튼 하이라이트
 * - 즉시 제출 (선택 시 자동 제출)
 */
export const OXInput: React.FC<OXInputProps> = ({ onSubmit, disabled = false }) => {
  const [selected, setSelected] = useState<'O' | 'X' | null>(null);

  /**
   * OX 선택 핸들러 (선택 시 즉시 제출)
   */
  const handleSelect = (choice: 'O' | 'X') => {
    if (disabled) return;

    setSelected(choice);

    // DB에 저장되는 값: O → 't', X → 'f'
    const answer = choice === 'O' ? 't' : 'f';

    // 짧은 딜레이 후 제출 (선택 애니메이션 보이도록)
    setTimeout(() => {
      onSubmit(answer);
    }, 300);
  };

  return (
    <div className="space-y-4">
      {/* OX 버튼 */}
      <div className="grid grid-cols-2 gap-4">
        {/* O 버튼 */}
        <PixelButton
          variant={selected === 'O' ? 'primary' : 'secondary'}
          size="large"
          onClick={() => handleSelect('O')}
          disabled={disabled}
          className="text-6xl py-8 hover:scale-105 transition-transform"
        >
          O
        </PixelButton>

        {/* X 버튼 */}
        <PixelButton
          variant={selected === 'X' ? 'primary' : 'secondary'}
          size="large"
          onClick={() => handleSelect('X')}
          disabled={disabled}
          className="text-6xl py-8 hover:scale-105 transition-transform"
        >
          X
        </PixelButton>
      </div>

      {/* 안내 메시지 */}
      <p className="text-center font-pixel text-xs text-gray-500">
        O 또는 X를 선택하면 자동으로 제출됩니다
      </p>
    </div>
  );
};
